import { render, staticRenderFns } from "./TreatmentDetails2.vue?vue&type=template&id=73b6380b&"
import script from "./TreatmentDetails2.vue?vue&type=script&lang=js&"
export * from "./TreatmentDetails2.vue?vue&type=script&lang=js&"
import style0 from "./TreatmentDetails2.vue?vue&type=style&index=0&id=73b6380b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports